import React, { Component } from "react";
import { point, distance } from "@turf/turf";

import { Translate } from "react-redux-i18n";

import { momentModule } from "../../utils/Utils";

import InfoModal from "../../utils/components/InfoModal";

// Parking
import outdoor_garage from "../../../styles/images/parking/borderless/outdoor_garage.svg";
import private_garage from "../../../styles/images/parking/borderless/private_garage.svg";
import public_indoorpark from "../../../styles/images/parking/borderless/public_indoorpark.svg";
import public_outdoorpark from "../../../styles/images/parking/borderless/public_outdoorpark.svg";
import street from "../../../styles/images/parking/borderless/street.svg";

// Vehicles
import bicycle from "../../../styles/images/vehicles/borderless/bicycle.svg";
import car from "../../../styles/images/vehicles/borderless/car.svg";
import moto from "../../../styles/images/vehicles/borderless/moto.svg";
import truck from "../../../styles/images/vehicles/borderless/truck.svg";

import "../../../styles/components/map/chargerInfo/PointInfo.scss";
import info from "../../../styles/images/info.svg";

const { moment } = momentModule;

class PointInfo extends Component {
  constructor(props) {
    super(props);
    this._mounted = false;

    this.state = {
      modals: {
        info: false,
      },
    };
  }

  componentDidMount() {
    this._mounted = true;
  }

  componentWillUnmount() {
    this._mounted = false;
  }

  getParkingIcon(type) {
    switch (type) {
      case "OutdoorGarage":
        return outdoor_garage;
      case "PrivateGarage":
        return private_garage;
      case "CoverParking":
        return public_indoorpark;
      case "OutdoorParking":
        return public_outdoorpark;
      case "Street":
        return street;
      default:
        return null;
    }
  }

  getVehicleIcon(type) {
    switch (type) {
      case "bicycle":
        return bicycle;
      case "car":
        return car;
      case "moto":
        return moto;
      case "truck":
        return truck;
      default:
        return null;
    }
  }

  getAvailability(type) {
    switch (type) {
      case "Always":
      case "Limited": {
        return <Translate value={`chargerPointFullDetails_availability${type}`} />;
      }
      default:
        return "-";
    }
  }

  distance() {
    if (this.props.currentLocation !== false) {
      const curLocation = point(this.props.currentLocation);
      const chargerCoords = this.props.charger.geometry.coordinates;
      const chargerLocation = point([chargerCoords[1], chargerCoords[0]]);
      const distance = this.calculateDistance(curLocation, chargerLocation);
      const time = this.calculateTime(distance);
      const m = moment.duration(time, "minutes");

      return distance + "km - " + (m.hours() > 0 ? m.hours() + "h " : "") + m.minutes() + "min";
    } else {
      return <Translate value="chargerPointFullDetails_noDistance" />;
    }
  }

  calculateDistance(curLocation, chargerLocation) {
    return (
      Math.round(
        (distance(curLocation, chargerLocation, { units: "kilometers" }) + Number.EPSILON) * 100
      ) / 100
    );
  }

  calculateTime(distance) {
    const avgCitySpeed = 25 / 60; // 25km/h in km/min
    const avgHighwaySpeed = 90 / 60; // 90km/h in km/min
    return distance < 10
      ? Math.round(distance / avgCitySpeed)
      : Math.round(distance / avgHighwaySpeed);
  }

  setModal(modal, bool) {
    let newModals = Object.assign({}, this.state.modals);
    newModals[modal] = bool;
    this.safeSetState({
      modals: newModals,
    });
  }

  safeSetState(params, callback) {
    if (this._mounted) this.setState(params, callback);
  }

  render() {
    return (
      <>
        <div id="pointInfo">
          <div className="description">
            <b>
              <Translate value="chargerPointFullDetails_chargingPointInfo" />
            </b>
            <p>
              {this.props.charger.properties.hasOwnProperty("infoPoint") ? (
                this.props.charger.properties.infoPoint
              ) : (
                <Translate value="chargerPointFullDetails_chargingPointNoInfo" />
              )}
            </p>
          </div>
          <div className="info">
            <div className="parking">
              <p>
                <Translate value="chargerPointFullDetails_parkingType" />
              </p>
              <img src={this.getParkingIcon(this.props.charger.properties.parkingType)} alt="" />
            </div>
            <div className="vehicles">
              <p>
                <Translate value="chargerPointFullDetails_vehicles" />
              </p>
              <div className="icons">
                {this.props.charger.properties.hasOwnProperty("vehiclesType") &&
                  this.props.charger.properties.vehiclesType.map((vehicleType, k) => (
                    <img
                      key={this.props.charger.properties.hwId + vehicleType.type + k}
                      src={this.getVehicleIcon(vehicleType.vehicle)}
                      alt=""
                    />
                  ))}
              </div>
            </div>
            <div className="availability">
              <p>
                <Translate value="chargerPointFullDetails_availability" />
                {this.props.charger.properties.availability.availabilityType !== "Always" && (
                  <button
                    type="button"
                    className="clear"
                    onClick={() => this.setModal("info", true)}
                  >
                    <img src={info} alt="" />
                  </button>
                )}
              </p>
              <b>
                {this.getAvailability(this.props.charger.properties.availability.availabilityType)}
              </b>
            </div>
            <div className="distance">
              <p>
                <Translate value="chargerDetails_distance" />
              </p>
              <b>{this.distance()}</b>
            </div>
          </div>
        </div>

        <InfoModal
          show={this.state.modals.info}
          onHide={() => this.setModal("info", false)}
          mode="availability"
          info={this.props.charger.properties.availability}
        />
      </>
    );
  }
}

export default PointInfo;
